import ToggleSettingSection from "../common/ToggleSettingSection";
import { __ } from "@wordpress/i18n";
import { useContext } from "react";
import { SettingsContext } from "../Settings";

const AdvancedSettings = () => {
  const { settings, sbyIsPro } = useContext(SettingsContext);

  return (
    <>
      <ToggleSettingSection
        title={__("AJAX theme loading fix", "feeds-for-youtube")}
        inputName={"ajaxtheme"}
        defaultChecked={settings.ajaxtheme}
        clearStyle={true}
      />
      <ToggleSettingSection
        title={__("Usage Tracking", "feeds-for-youtube")}
        inputName={"usagetracking"}
        helpText={__(
          "This helps us prevent plugin and theme conflicts by sending a report in the background once per week about your settings and relevant site stats. It does not send sensitive information like access tokens, email addresses, or user info. This will not affect your site performance as well. <a href='https://smashballoon.com/youtube-feed/docs/usage-tracking/' target='_blank'>Learn More</a>",
          "feeds-for-youtube"
        )}
        defaultChecked={settings.usagetracking}
      />
      {sbyIsPro ? (
        ""
      ) : (
        <ToggleSettingSection
          title={__("Cron Clear Cache", "feeds-for-youtube")}
          inputName={"cronclear"}
          helpText={__(
            "If your YouTube feed is not updating, your WordPress installation may have a rare issue with clearing temporary data in your database. Enable this setting to use WordPress cron to clear your feed caches.",
            "feeds-for-youtube"
          )}
          clearStyle={true}
          defaultChecked={settings.cronclear}
        />
      )}
      <ToggleSettingSection
        title={__("Custom Templates", "feeds-for-youtube")}
        inputName={"customtemplates"}
        helpText={__(
          "The default HTML for the feed can be replaced with custom templates added to your theme's folder. Enable this setting to use these templates. See <a href='https://smashballoon.com/doc/guide-to-creating-custom-templates/' target='_blank'>this guide</a>.",
          "feeds-for-youtube"
        )}
        defaultChecked={settings.customtemplates}
        clearStyle={true}
      />
      <ToggleSettingSection
        title={__("Enqueue JavaScript in header", "feeds-for-youtube")}
        inputName={"enqueue_js_in_head"}
        helpText={__(
          "Add the JavaScript file for the plugin in the header instead of the footer",
          "feeds-for-youtube"
        )}
        defaultChecked={settings.enqueue_js_in_head}
      />
      <ToggleSettingSection
        title={__("Disable WP Posts", "feeds-for-youtube")}
        inputName={"disable_wp_posts"}
        helpText={__(
          "This will disable the feature that saves each video as a WordPress post.",
          "feeds-for-youtube"
        )}
        defaultChecked={settings.disable_wp_posts}
      />
    </>
  );
};
export default AdvancedSettings;
